import { Box, Card, CardContent, Divider } from '@mui/material'
import HistoryItemField from '@component/HistoryItemField'
import { Looks4Rounded } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { FoundationInput } from '@core/const'
import { FoundationResponse } from '@core/query'
import AreaUnit from '@component/AreaUnit'

export interface FoundationHistory extends FoundationInput {
  type: 'Foundation',
  result: FoundationResponse
}

interface Props {
  history: FoundationHistory
}
function FoundationHistoryItem ({ history }: Props) {
  const { t } = useTranslation()

  const rcResult = `${(+history.result.criterionSize).toFixed(0)} x ${(+history.result.calculatedSizeForLateral).toFixed(0)}`

  return (
    <Card>
      <CardContent className="flex gap-16 !py-8">
        <Looks4Rounded />
        <Box className="relative">
          <Box className="grid grid-cols-2 gap-8 min-w-[16rem] overflow-auto">
            <HistoryItemField
              label={t('GLOSSARY.LONGSIDE_SPAN')}
              unit="m"
              value={history.longSideSpan}
            />
            <HistoryItemField
              label={t('GLOSSARY.SHORTSIDE_SPAN')}
              unit="m"
              value={history.shortSideSpan}
            />
            <HistoryItemField
              label={t('WORD.USAGE')}
              value={t(`GLOSSARY.USAGE.${history.usage}`)}
            />
            <HistoryItemField
              label={t('GLOSSARY.SLAB_THICKNESS')}
              value={history.slabThickness}
            />
            <HistoryItemField
              label={t('WORD.STORIES')}
              value={history.stories}
            />
            <HistoryItemField
              label={t('GLOSSARY.BEARING_CAPACITY')}
              unit="kN/m2"
              value={history.bearingCapacity}
            />
            <HistoryItemField
              label={t('GLOSSARY.CRITERION_SIZE')}
              unit="mm"
              value={history.criterionSize}
            />
          </Box>
        </Box>
        <Box>
          <Divider orientation="vertical" />
        </Box>
        <Box className="flex flex-col gap-8">
          <HistoryItemField
            label={t('GLOSSARY.THICKNESS')}
            unit="mm"
            value={history.result.needHeight.toFixed(0)}
          />
          <HistoryItemField
            label={t('GLOSSARY.RATIO_VUPHIVC')}
            value={history.result.finalRatio.toFixed(2)}
          />
          <HistoryItemField
            label={t('GLOSSARY.MIN_REQUIRED_LATERAL_AREA')}
            unit={<AreaUnit />}
            value={rcResult}
          />
        </Box>
      </CardContent>
    </Card>
  )
}

export default FoundationHistoryItem
